import React, { useState } from "react";
import { ReactComponent as CloseIcon } from "../../assets/novosicones/Login/cancel_black_24dp.svg";
import { ReactComponent as Phone } from "../../assets/novosicones/Login/phone_black_24dp.svg";
import { Link } from "react-router-dom";
// import { registraAtendimento } from "../../services/meAjuda";
import "./styles.scss";
const PrecisaDeAjuda = ({ posicaoY }) => {
  const url = window.location.href.toString();

  const [showPhone, setShowPhone] = useState(false);

  const handleShowPhone = async (e) => {
    e.preventDefault();
    setShowPhone(!showPhone);
  };

  return (
    url.split("//")[1].split("/")[1] != "" && (
      <div
        className="precisaDeAjuda"
        style={{
          position: "absolute",
          bottom: posicaoY != "" ? posicaoY : "30px",
          fontSize: "12px",
          color: "#1D3054",
        }}
      >
        <a style={{ textDecoration: "underline" }}>
          <div style={{ position: "relative" }}>
            <span className="precisaDeAjuda__link" onClick={handleShowPhone}>
              Precisa de ajuda?
            </span>
            {showPhone && (
              <div className="precisaDeAjuda__modal">
                <div
                  className="centralized-space-between"
                  style={{ marginBottom: "8px" }}
                >
                  <span className="precisaDeAjuda__modal__centralRelacionamento">
                    Central de relacionamento
                  </span>
                  <span
                    onClick={handleShowPhone}
                    className="precisaDeAjuda__modal__close"
                  >
                    <CloseIcon />
                  </span>
                </div>
                <span className="precisaDeAjuda__modal__horario">
                  De segunda a sexta feira, <br /> das 9h às 17h
                </span>
                <div className="centralized precisaDeAjuda__modal__cliqueAqui">
                  <Link to="/precisa-de-ajuda">
                    CLIQUE AQUI E FALE CONOSCO
                  </Link>
                </div>
                <div className="centralized-space-between precisaDeAjuda__modal__phone">
                  <div className="centralized precisaDeAjuda__modal__phone__icon">
                    <Phone />
                  </div>
                  <div className="centralized precisaDeAjuda__modal__phone__number">
                    31-4002-2600
                  </div>
                </div>
              </div>
            )}
          </div>
        </a>
      </div>
    )
  );
};

export default PrecisaDeAjuda;
